<template>
  <main>
    <AddTodo @onInputEnter="addTodo" @onInputBtnClick="addTodo"></AddTodo>
    <TodoList 
      :enteredInput="enteredInput" 
      :todoList="todoList"
      @update-checked-state="updateCheckedState"
      @clear-completed="clearCompleted"
      :todoCount="todoList.length"
      :todoTypeProp="todoType"
      
      @active-todos="showActiveTodos"
      @all-todos="showAllTodos"
      @completed-todos="showCompletedTodos"
      
    >
    </TodoList>
    <FooterTabsForMobile
      @active-todos="showActiveTodos"
      @all-todos="showAllTodos"
      @completed-todos="showCompletedTodos"
    >
    </FooterTabsForMobile>
  </main>
</template>

<script>
import AddTodo from "./AddTodo/TheAddTodo.vue";
import TodoList from "./Todos/TodoList.vue";
import FooterTabsForMobile from "./Tabs/TheFooterTabsMobile.vue";

export default {
  name: "TheMain",
  components: { AddTodo, TodoList, FooterTabsForMobile },
  data() {
    return {
      todoList: [
          { id: 0, date:new Date(), item: "this is the first todo item",  isComplete: true  },
          { id: 1, date:new Date(), item: "this is the second todo item", isComplete: false },
          { id: 2, date:new Date(), item: "this is the third todo item",  isComplete: false },
      ],
      enteredInput: '',
      todoType: 'All'
    }
  },
  computed: {
    inCompleteTodoArray : function() {
      return this.todoList.filter((item) => {
        if (item.isComplete !== true) return item
      })
    },
  },
  methods: {
    addTodo: function(data) {
      this.enteredInput = data; // to pass data using prop

      let lastTodoObj = this.todoList[this.todoList.length - 1];

      let nextTodoId;
      if (lastTodoObj) nextTodoId = lastTodoObj.id + 1;
      else nextTodoId = 0; // if there are no todo
 
      if (this.enteredInput) {
        this.todoList.push({
          id: nextTodoId++,
          date: new Date(),
          item: String(this.enteredInput), 
          isComplete: false 
        });
      }
      localStorage.setItem('todoList',JSON.stringify(this.todoList));
    },

    updateCheckedState: function(checkboxState, checkedTodoId) {
      let checkedTodo = this.todoList[checkedTodoId];

      if (checkedTodo) checkedTodo.isComplete = checkboxState;
      localStorage.setItem('todoList',JSON.stringify(this.todoList));
    },

    clearCompleted: function() {
      this.todoList = this.inCompleteTodoArray;
    },
    // footer tabs
    showAllTodos: function() {
        this.todoType = "All"
    },
    showActiveTodos: function() {
        this.todoType = 'Active'
    },
    showCompletedTodos: function() {
        this.todoType = "Completed"
    }
  },
  created() {
    let localStorageData = localStorage.getItem('todoList');
    if (localStorageData) {
      try {
        this.todoList = JSON.parse(localStorageData);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("localStorage item doesn't exist or not valid");
      }
    }
  },
};
</script>

<style>

  :root {
    --main-margin: 6.4vw;
    --main-width: calc(100vw - (var(--main-margin)) * 2);
  }
  
  main {
    width: clamp(200px, var(--main-width), 540px);
    /* height: max(200px, 67.94520547945206vh); */
    margin: 0 var(--main-margin);
    isolation: isolate;
  }

</style>
